import { Box, Stack, Typography } from "@mui/material";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { t } from "i18next";
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { appLogo } from "../../../assets";
import AppLoader from "../../../components/AppLoader";
import LanguageMenu from "../../../components/LanguageMenu";
import SubscriptionPurchaseDialog from "../../../components/subscriptionPaymentDialog.js";
import { STRIPE_KEY } from "../../../constants/Variables.js";
import { getAllSubscriptionByRole } from "../../../services/admin/adminAllApiFn";
import { companyPurchaseSubscripton } from "../../../services/company/authenticationApiFn";
import { supplierPurchaseSubscription } from "../../../services/supplier/authenticationApiFn";
import { supplierProductsStatusOffOnDowngrade } from "../../../services/supplier/productApiFn";
import { workerPurchaseSubscription } from "../../../services/worker/authenticationApiFn.js";
import { handleOpenSnackBar } from "../../../utils";
import SubscriptionCard from "./SubscriptionCard";

const stripePromise = loadStripe(STRIPE_KEY);

const PurchaseSubscription = () => {
  const openSubscriptionDialog = useRef(null);
  const navigate = useNavigate();
  const { state } = useLocation();
  const [allSubscription, setAllSubscription] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!state) {
      navigate("/");
    }
  }, [state, navigate]);

  useEffect(() => {
    if (state) {
      fetchAllSubscriptions();
    }
  }, [state]);

  // Fetching all the subscription according to Account type;

  const fetchAllSubscriptions = async () => {
    try {
      setIsLoading(true);
      const response = await getAllSubscriptionByRole(state?.type);
      if (response?.data?.status === "success") {
        setAllSubscription(response?.data?.data);
      } else {
        handleOpenSnackBar("error", response?.data?.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  // Company upgration functions to upgrade the subscription package

  // Navigate to Services page where company select their categories according to their package

  const handleNavigateToServicesPage = (subscription) => {
    navigate("/select-service", {
      state: { type: state?.type, user: state?.user, subscription },
    });
  };

  // If company resubscribe their package

  const handleCompanyResubscribePackage = async (subscription) => {
    openSubscriptionDialog.current.openDialog({
      subscription: subscription,
      type: "upgrade",
      warningText: t("alreadySubscribed"),
    });
  };

  // Supplier upgration functions to upgrade the subscription package

  // Open persmission Alert to ask permission

  const handleOpenPermissionAlertForSupplier = async (subscription) => {
    // New supplier

    if (state.subscriptionId === "" || state.subscriptionId === null) {
      return openSubscriptionDialog.current.openDialog({
        subscription: subscription,
        type: "newSupplier",
        warningText: t("confirmSubscription"),
      });
    }

    const previous = state?.subscriptionId?.features[0]?.specifics?.maxProducts;
    const current = subscription?.features[0]?.specifics.maxProducts;

    // down grade

    if (previous > current) {
      openSubscriptionDialog.current.openDialog({
        subscription: subscription,
        type: "downGrade",
        warningText: t("downgradeWarning"),
      });
    }

    // upgrade Package

    if (previous < current) {
      openSubscriptionDialog.current.openDialog({
        subscription: subscription,
        type: "same",
        warningText: t("upgradeInfo"),
      });
    }

    // same Package

    if (previous === current) {
      openSubscriptionDialog.current.openDialog({
        subscription: subscription,
        type: "upgrade",
        warningText: t("alreadySubscribed"),
      });
    }
  };

  const handleOpenPermissionAlertForWorker = async (subscription) => {
    openSubscriptionDialog.current.openDialog({
      subscription: subscription,
      type: "newSupplier",
      warningText: t("confirmSubscription"),
    });
  };

  const handlePurchaseSubscriptionForSupplier = async (params) => {
    try {
      const payload = {
        supplierId: state?.user,
        subscriptionId: params?.subscription?._id,
        tokenId: params?.tokenId,
        type: params.type,
      };
      setIsLoading(true);
      const response = await supplierPurchaseSubscription(payload);
      if (response?.data?.status === "success") {
        navigate("/login", { state: { type: state?.type } });
        openSubscriptionDialog.current.closeDialog();
        handleOpenSnackBar("success", response?.data?.message);
        if (params.type === "downGrade") {
          await supplierProductsStatusOffOnDowngrade(state?.user);
        }
      } else {
        handleOpenSnackBar("error", response?.data?.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePurchaseSubscriptionForWorker = async (params) => {
    try {
      const payload = {
        workerId: state?.user,
        subscriptionId: params?.subscription?._id,
        tokenId: params?.tokenId,
        type: params.type,
      };
      setIsLoading(true);
      const response = await workerPurchaseSubscription(payload);
      if (response?.data?.status === "success") {
        // navigate("/login", { state: { type: state?.type } });

        navigate(`/worker/shedule/${state?.user}/${state?.type}`);

        openSubscriptionDialog.current.closeDialog();
        handleOpenSnackBar("success", response?.data?.message);
      } else {
        handleOpenSnackBar("error", response?.data?.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePurchaseCompanySubscription = async (params) => {
    console.log(params, "paramsssssssssssss");
    try {
      let payload = {
        subscriptionId: params?.subscription?._id,
        companyId: state?.user,
        tokenId: params?.tokenId,
        type: "Update",
        subscriptionType: params?.type,
      };

      setIsLoading(true);
      const response = await companyPurchaseSubscripton(payload);

      if (response.data.status === "success") {
        handleOpenSnackBar("success", response.data.message);
        navigate("/login", { state: { type: state?.type } });
      } else {
        handleOpenSnackBar("error", t("updateError"));
      }
    } catch (error) {
      handleOpenSnackBar("error", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <AppLoader isVisible={isLoading} />
      <Box
        sx={{
          background: "linear-gradient(to bottom, #f7f9fc, #e8ecf1)",
          minHeight: "100vh",
          py: 8,
        }}
      >
        {/* Header with Logo */}
        <Stack
          px={2}
          py={1}
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          boxShadow="rgba(0, 0, 0, 0.15) 0px 1px 15px 0px"
          position="fixed"
          top={0}
          right={0}
          left={0}
          zIndex={1}
          bgcolor="white"
        >
          <img
            src={appLogo.eazidayLogoNew}
            alt="app-logo"
            width={40}
            style={{ height: "auto", transition: "transform 0.2s" }}
            onClick={() => navigate("/")}
          />

          <LanguageMenu />
        </Stack>

        {/* Main Title */}
        <Stack mt={10} alignItems="center" spacing={1}>
          <Typography
            variant="h4"
            fontWeight={600}
            color="primary.main"
            sx={{ textShadow: "0px 3px 8px rgba(0,0,0,0.1)" }}
          >
            {t("upgradeSubscription")}
          </Typography>
          <Typography
            variant="subtitle1"
            color="textSecondary"
            align="center"
            mt={1}
            maxWidth="80%"
            sx={{ fontSize: "1rem", fontStyle: "italic" }}
          >
            {t("upgradeMessage")}
          </Typography>
        </Stack>

        {/* Subscription Cards */}
        <Box
          mt={4}
          px={3}
          display="flex"
          flexWrap="wrap"
          justifyContent="center"
          gap={3}
        >
          <SubscriptionCard
            data={allSubscription}
            setIsLoading={setIsLoading}
            handleUpdateSubscription={(data) => {
              const samePackageCompany =
                state.type === "company" && state?.subscriptionId === data?._id;
              const differentCompanyPackage =
                state.type === "company" && state?.subscriptionId !== data?._id;
              const newSupplier =
                state.type === "supplier" &&
                (state?.subscriptionId === "" ||
                  state?.subscriptionId === null);
              const upgradeSupplier =
                state.type === "supplier" &&
                (state?.subscriptionId !== "" ||
                  state?.subscriptionId !== null);

              const newWorker = state.type === "worker";

              if (samePackageCompany) {
                handleCompanyResubscribePackage(data);
              }
              if (differentCompanyPackage) {
                handleNavigateToServicesPage(data);
              }
              if (newSupplier) {
                handleOpenPermissionAlertForSupplier(data);
              }
              if (upgradeSupplier) {
                handleOpenPermissionAlertForSupplier(data);
              }
              if (newWorker) {
                handleOpenPermissionAlertForWorker(data);
              }
            }}
          />
        </Box>
      </Box>

      {/* <PermissionAlert
        ref={openAlert}
        onAllow={handleUpdateSupplierSubscription}
      /> */}

      <Elements stripe={stripePromise}>
        <SubscriptionPurchaseDialog
          ref={openSubscriptionDialog}
          onPayment={(data) => {
            const samePackageCompany =
              state.type === "company" &&
              state?.subscriptionId === data.subscription?._id;

            const isWorker = state?.type === "worker";

            if (samePackageCompany) {
              handlePurchaseCompanySubscription(data);
            } else if (isWorker) {
              handlePurchaseSubscriptionForWorker(data);
            } else {
              handlePurchaseSubscriptionForSupplier(data);
            }
          }}
        />
      </Elements>
    </>
  );
};

export default PurchaseSubscription;
